import { render, staticRenderFns } from "./TreeNodeCard.vue?vue&type=template&id=483c7b74&scoped=true"
import script from "./TreeNodeCard.vue?vue&type=script&lang=js"
export * from "./TreeNodeCard.vue?vue&type=script&lang=js"
import style0 from "./TreeNodeCard.vue?vue&type=style&index=0&id=483c7b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c7b74",
  null
  
)

export default component.exports